import {useIntl} from 'react-intl';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalCloseButton,
  Heading,
  Text,
  Button,
  ModalProps,
} from '@chakra-ui/react';
import {useToast} from '@chakra-ui/toast';

import {useTranslate} from '@eksab/i18n';
import {CoinsIcon5} from '@eksab/assets/icons';
import {LinkIcon} from '@chakra-ui/icons';

import {useAppSettingsQuery, useMeQuery} from '@eksab/hooks';

import {config} from '@eksab/config';

export const ReferralModal = (props: Omit<ModalProps, 'children'>) => {
  const format = useIntl().formatNumber;
  const {data: settings} = useAppSettingsQuery();

  const referrerLinkBase = `${config.baseURL}/register?referrer=`;

  const me = useMeQuery().data;

  const t = useTranslate();

  const toast = useToast();
  const copyToClipboard = (text: string) =>
    navigator.clipboard
      .writeText(text)
      .then(() => toast({title: t('app.referer-link.copied'), status: 'success'}))
      .catch((e) => toast({title: t('app.errors.try-again'), status: 'error'}));

  return (
    <Modal motionPreset="slideInBottom" variant="full" size="sm" {...props}>
      <ModalOverlay />

      <ModalContent px="6" textAlign={['start', 'center']} rounded="xl" shadow="sm" overflow="hidden" mb="10">
        <ModalHeader display="flex" flexDir="column" gap="3" mt={[7, 20]} px={[0, 2]} py="1">
          <Heading textTransform="capitalize" fontSize={['md', 'xl']} fontWeight="800">
            {t('competition.modal.buy.heading')}
          </Heading>

          <Text fontSize={['sm', 'md']} fontWeight="500" data-testid="buy-coins-to-join">
            {t(`app.earn-coins-banner.user`, {
              referralRewardForRegistration: settings?.referral_reward_coins,
              referralRewardPercentageForPayments: (settings?.referral_reward_percentage_for_payments as number) * 100,
              referralRewardCapForPayments: settings?.referral_reward_cap_for_payments,
              b: (amount) => (
                <>
                  <CoinsIcon5 me="1" />

                  <Text as="span" color="#FFCD2B" lineHeight="36px" fontSize="md" fontWeight="700">
                    {format(+amount[0]!)}
                  </Text>
                </>
              ),
            })}
          </Text>
        </ModalHeader>
        <ModalCloseButton top="4" size="lg" />

        <ModalFooter pt="0" px="0" pb="9" mt="10">
          <Button
            w={['full', null, 'center']}
            minW="40"
            rightIcon={<LinkIcon />}
            onClick={() => {
              copyToClipboard(referrerLinkBase + me!.settings.referral_code);
              mixpanel?.track('Button Clicked', {button: 'referring.invite_friend'});
            }}
          >
            {t('app.actions.copy-link')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
